import { Action, combineReducers } from "redux";
import { ICompanyPage } from "source/models/company/companyPage";

// State
export interface ICompanyPageState {
    dataId: number;
    companyPage: ICompanyPage;
}

export interface ICompanyState {
    page: ICompanyPageState;
}

// Action type constants
const COMPANY_SUCCESS = "COMPANY_SUCCESS";
const COMPANY_FAILURE = "COMPANY_FAILURE";

type T_COMPANY_SUCCESS = typeof COMPANY_SUCCESS;
type T_COMPANY_FAILURE = typeof COMPANY_FAILURE;

// Action types
interface ICompanySuccess extends Action {
    type: T_COMPANY_SUCCESS;
    companyPage: ICompanyPage;
}

interface ICompanyFailure extends Action {
    type: T_COMPANY_FAILURE;
}

export type CompanyAction =
    | ICompanySuccess
    | ICompanyFailure;

//Actions
export const companySuccess = (companyPage: ICompanyPage): ICompanySuccess => ({
    type: COMPANY_SUCCESS,
    companyPage
});

export const companyFailure = (): ICompanyFailure => ({
    type: COMPANY_FAILURE
});

//Reducers
export const companyInitialState: ICompanyState = {
    page: {
        dataId: 0,
        companyPage: null
    }
};

const page = (state: ICompanyPageState = null, action: CompanyAction) => {
    switch (action.type) {
    case COMPANY_SUCCESS: {
        const companySuccess = action as ICompanySuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            companyPage: companySuccess.companyPage
        };
    }
    case COMPANY_FAILURE:
        return { ...state };
    }
    return state;
};

//Root reducer
export const companyReducer = combineReducers({
    page
});

//Utils